import { LabelValuesResource } from '~src/catalog/resources/LabelValues';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ExplorableItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { getNoDefaultFilters } from '~src/spacesPlatform/contentDefinitions/getDefaultFilters';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';

export const LabelValueDefinition: SpaceDefinition<'labelValue'> & ExplorableItemDefinition = {
  itemType: 'labelValue',
  contentType: 'labelValue',
  singularName: Messages.label,
  pluralName: Messages.labels,
  emptyStateMessage: Messages.contentEmptyMessage,
  contentFilterKeys: [],
  filterClause: null,
  defaultFilters: getNoDefaultFilters,
  supportedDisplayModes: ['list'],
  cardComponent: GenericCard,
  listViewIconType: null,
  contentSpaceUrl: (urls, id) => '',
  headerIconPath: (contentInfo: ISpaceItemDetailInfo<'labelValue'>) => {
    return imgPath('labels_tagIcon.svg');
  },
  getContentInfo: () => {
  },
  getBasicQuery: () => {
    return LabelValuesResource.instance.all();
  },
  getResourceTokenQuery: () => {
    return null;
  }
};